import type { SVGAttributes } from 'react';

export function FilterYearIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props} viewBox="0 0 24 24">
			<rect width="24" height="24" fill="currentColor" fillOpacity=".1" rx="4" />
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit="10"
				d="M9.333 5.333v2m5.334-2v2m0-1c2.22.12 3.333.967 3.333 4.1v4.12c0 2.747-.667 4.12-4 4.12h-4c-3.333 0-4-1.373-4-4.12v-4.12C6 7.3 7.113 6.46 9.333 6.333zm3.166 9.4H6.167"
			/>
			<path
				fill="currentColor"
				d="M12 9.5c-.82 0-1.513.447-1.513 1.313 0 .414.193.727.486.927-.406.24-.64.627-.64 1.08 0 .827.634 1.34 1.667 1.34 1.027 0 1.667-.513 1.667-1.34 0-.453-.234-.847-.647-1.08.3-.207.487-.513.487-.927 0-.866-.687-1.313-1.507-1.313m0 1.893c-.347 0-.6-.206-.6-.533 0-.333.253-.527.6-.527s.6.194.6.527c0 .327-.253.533-.6.533m0 1.94c-.44 0-.76-.22-.76-.62s.32-.613.76-.613.76.22.76.613c0 .4-.32.62-.76.62"
			/>
		</svg>
	);
}
